var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hp-label',{staticClass:"mr-1 mb-1",attrs:{"color":_vm.tagClass,"title":_vm.skillLevelName,"data-toggle":"tooltip"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }